import React, {useEffect, useRef, useState} from "react";
import styles from "./Maintenance.module.css"
import {
    createIndices,
} from "../../services/api";
import {
    setInfoMessage,
    useGlobalDispatch,
    useGlobalState
} from "../../context/GlobalState";


const Maintenance = () => {
    const dispatch = useGlobalDispatch();
    const {theme, layout, profile, loading} = useGlobalState();

    const createIndexHandler = () => {
        createIndices().then(dispatch(setInfoMessage("done!")));
    }

    return (
        <div className={styles['container']}>
            <button
                onClick = {createIndexHandler}
                >Create indices</button>
        </div>
    );
};

export default Maintenance;
